<template>
  <div id="app" class="">
    <transition name="fade">
      <v-loader v-if="isLoading"/>
    </transition>
    <div class="header" v-if="!isLoading">
      <div class="container mx-auto px-3">
        <h1 class="text-4xl font-bold">Your Al&nbsp;Mouj&nbsp;Muscat Home Selections</h1>
        <img src="./assets/images/almouj-logo.png" alt="Al Mouj Muscat">
      </div>
    </div>    
    <transition name="fade">
      <div v-if="!isLoading && !isValidFavourites" class="text-center mb-6 flex items-center justify-center text-white" style="height:30vh;">No properties to display.</div>
    </transition>
    <transition name="fade">
      <v-favourites v-if="!isLoading && isValidFavourites"/>
    </transition>
    <v-footer/>
    <transition name="fade">
      <lead-form-modal
        v-if="!isLoading && isValidFavourites && !isReturningUser && isLeadFormTimeoutFinished && !isLeadFormSubmitted"
        @submitted="isLeadFormSubmitted = true"
      />
    </transition>
  </div>
</template>

<script>
import LeadFormModal from './components/LeadFormModal'
import VLoader from './components/VLoader'
import VFavourites from './components/VFavourites'
import VFooter from './components/VFooter'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'App',
  components: {
    LeadFormModal,
    VLoader,
    VFavourites,
    VFooter
  },

  data () {
    return {
      isLeadFormSubmitted: false
    }
  },

  computed: {
    ...mapGetters([
      'isLeadFormTimeoutFinished',
      'isLoading',
      'isReturningUser',
      'isValidFavourites',
    ]),
  },

  created () {
    this.fetchData()
  },

  methods: {
    ...mapActions([
      'fetchData'
    ])
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_fonts';
@import '@/assets/styles/_variables';

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: $navy;
  color: $body-text-color;
  font-family: $font-sans;
  min-height: 100vh;
}

#app {
  display: flex;
  flex-direction: column;
}

.font-serif {
  font-family: $font-serif
}

.header {
  background-color: $navy;
  color: #fff;
  padding: 30px 0;

  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      text-align: center;
      
      img {
        margin-bottom: 20px;
      }
    }
  }

  img {
    object-fit: contain;
    width: 100px;
  }
}

</style>
